import { ModalProps } from "@inntechcorp/it-design";

export const EmptyModalStruct:ModalProps = {
  id                          : "",
  title                       : null,
  width                       : "440px",
  closeOnClickOutside         : true,
  preventESC                  : false,
  showOkButton                : true,
  showCancelButton            : true,
  showCloseButton             : true,
  okButtonText                : "",
  cancelButtonText            : "",
  customProps                 : {},
  onOk                        : null,
  onCancel                    : null,
  content                     : null,
  context                     : null,
  okButtonProps               : null,
  cancelButtonProps           : null,
}